let convert_callable_strings_to_js = function (obj) {
    for (const key in obj) {
        if (obj[key] && typeof obj[key] === 'object') {
            // If the value is an object, process it recursively
            convert_callable_strings_to_js(obj[key]);
        } else if (obj[key] && typeof obj[key] === 'string') {
            try {
                // Trim unnecessary spaces
                const trimmedString = obj[key].replace(/\s+/g, ' ').trim();

                // Check if the string starts with $, function, or window
                if (/^(\$|function|window)/.test(trimmedString)) {
                    obj[key] = new Function(`return (${trimmedString})`)();
                }
            } catch (error) {
                console.error(`Failed to execute key "${key}":`, error);
            }
        }
    }
}

export default convert_callable_strings_to_js;
